import * as React from "react";

function FlashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    d: "M11.934 6.876a.445.445 0 00-.378-.21H8.445v-4.89a.444.444 0 00-.843-.198l-3.555 7.11a.445.445 0 00.397.644h3.112v4.889a.445.445 0 00.842.199l3.555-7.111a.445.445 0 00-.02-.433z"
  }));
}

export default FlashIcon;